import { memo, useMemo } from "react";

import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { User } from "@hl/shared-features/lib/features/auth/User";
import { getLiveFormat } from "@hl/shared-features/lib/features/live-v2/livedate";
import { maskAddress } from "@hl/shared-features/lib/utils/content";
import { Box, Text, Anchor, Flex } from "@mantine/core";

import { Minter } from "~features/MintPage/live-minting/Minter";

export const MinterRow = memo(
  ({
    user,
    time,
    price,
    amount,
    blockExplorerUrl,
    highlighted,
    onAnimationEnd,
    onMouseEnterLink,
    onMouseLeaveLink,
    now,
  }: Minter & {
    highlighted: boolean;
    onAnimationEnd?: () => void;
    onMouseEnterLink?: () => void;
    onMouseLeaveLink?: () => void;
    now: number;
  }) => {
    const formattedTime = useMemo(() => getLiveFormat(time, now), [time, now]);

    const displayName = user.name ?? user.ens;

    return (
      <Flex
        align="center"
        justify="space-between"
        py={8}
        sx={(theme) => ({
          filter: highlighted ? "blur(0.3px)" : undefined,
          transition: "all 400ms ease",
          color: highlighted
            ? theme.fn.themeColor(TEXT_COLOR.TERTIARY)
            : theme.fn.themeColor(TEXT_COLOR.SECONDARY),
        })}
        onTransitionEnd={(event) => {
          event.stopPropagation();
          onAnimationEnd?.();
        }}
      >
        <Box
          sx={{ flex: 3 }}
          onMouseEnter={onMouseEnterLink}
          onMouseLeave={onMouseLeaveLink}
        >
          <User
            displayName={
              displayName ? displayName : maskAddress(user.address, 6, 4) ?? ""
            }
            walletAddresses={[user.address]}
            enableLink
            bold
            numLines="1"
            small
            newTab={false}
            textAlign="left"
            textProps={{
              sx: { color: "inherit" },
            }}
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: 110,
            }}
          />
        </Box>
        <Text size="sm" sx={{ color: "inherit", flex: 1 }}>
          {amount}x
        </Text>
        <Text size="sm" sx={{ color: "inherit", flex: 2 }}>
          {price}
        </Text>
        <Anchor
          onMouseEnter={onMouseEnterLink}
          onMouseLeave={onMouseLeaveLink}
          size="sm"
          href={blockExplorerUrl}
          target="_blank"
          sx={{ color: "inherit", flex: 2 }}
        >
          <Text
            size="sm"
            sx={{
              color: "inherit",
            }}
          >
            {formattedTime}
          </Text>
        </Anchor>
      </Flex>
    );
  }
);
